export const CASE_CLASSIFICATION_TYPE = {
  MEDICAL: "medical",
  NONMEDICAL: "nonmedical"
};

export const CASE_CLASSIFICATION_NAME = {
  MEDICAL: "Clinical case",
  NONMEDICAL: "Post"
};
